<template>
    <div>
        <div class="luetfrink-collapse collapsed text-secondary" id="collapseHeadDach" data-toggle="collapse" href="#collapseDach" role="button" aria-expanded="false" aria-controls="collapseDach"> 
            <span>Dach</span>
            <img class="luetfrink-collapse-img" src="./../../assets/img/down.svg" alt="Sektion Dach Collapse-Pfeil"> 
        </div>
        <div class="collapse" id="collapseDach" tabindex="-1" @focus="focusDach">
            <div class="card card-body luetfrink-collapse-card">
                <label>Dachform</label>
                <div>
                    <div class="custom-image-control custom-checkbox" >
                        <input v-model="dachform" type="radio" class="custom-image-checkbox" name="checkDachform" id="checkSatteldach" value="Satteldach" required>
                        <label class="custom-image-label checkSatteldachLabel" for="checkSatteldach" id="checkSatteldachLabel" data-toggle="tooltip" data-placement="top" title="Satteldach"></label>
                    </div>
                    <div class="custom-image-control custom-checkbox" >
                        <input v-model="dachform" type="radio" class="custom-image-checkbox" name="checkDachform" id="checkWalmdach" value="Walmdach" required>
                        <label class="custom-image-label checkWalmdachLabel" for="checkWalmdach" id="checkWalmdachLabel" data-toggle="tooltip" data-placement="top" title="Walmdach"></label>
                    </div>

                    <div class="custom-image-control custom-checkbox">
                        <input v-model="dachform" type="radio" class="custom-image-checkbox" name="checkDachform" id="checkPultdach" value="Pultdach" required>
                        <label class="custom-image-label checkPultdachLabel" for="checkPultdach" id="checkPultdachLabel" data-toggle="tooltip" data-placement="top" title="Pultdach"></label>
                    </div>
                </div>
                <label class="mt-3">Art der Deckunterlage <span class="badge badge-pill badge-primary" data-toggle="tooltip" data-placement="top" title="Bei Dächern ohne Deckunterlage ist die Überprüfung durch einen Sonderfachmann notwendig!">i</span></label>
                <select v-model="deckunterlage"  @focus="focusDach" class="form-control form-control-sm luetfrink-input" name="inDeckunterlage" id="inputDeckunterlage" required>
                    <option selected disabled value="" hidden>Bitte auswählen</option>
                    <option >Geschlossene Deckunterlage</option>
                    <option>Unterspannung</option>
                    <option>Keine Deckunterlage</option>
                </select>
                <div class="form-group mt-3">
                    <label for="inputDachneigung">
                        Dachneigung (10-65°)
                    </label>
                    <input v-model="dachneigung" v-bind:class="[(dachneigung < 10 || dachneigung > 65) && dachneigung != '' ? 'input-notallowed' : '']" @focus="focusDach" type="number" step="0.01" min="10" max="65" class="form-control form-control-sm luetfrink-input" id="inputDachneigung" name="inDachneigung" placeholder="" value="" required>
                </div>
                <div class="form-group" id="walmneigung" v-if="dachform == 'Walmdach'">
                    <label for="inputWalmdachneigung">
                        Walmdachneigung (10-89°)
                    </label>
                    <input v-model="walmneigung"  v-bind:class="[(walmneigung < 10 || walmneigung > 89) && walmneigung != '' ? 'input-notallowed' : '']" @focus="focusDach" type="number" step="0.01" min="10" max="89" class="form-control form-control-sm luetfrink-input" id="inputWalmdachneigung" name="inWalmdachneigung" placeholder="" required>
                </div>
                <div class="form-group ">
                    <label for="inputTraufe">
                        Länge der Traufe (3-100m)
                    </label>
                    <input v-model="trauflaenge" v-bind:class="[(trauflaenge < 3 || trauflaenge > 100) && trauflaenge != '' ? 'input-notallowed' : '']" @focus="focusDach" type="number" step="0.01"  min="3" max="100" class="form-control form-control-sm luetfrink-input" id="inputTraufe" name="inTraufe" placeholder="" value="" required>
                </div>
                <div class="form-group" id="giebel" v-if="dachform != 'Walmdach'">
                    <label for="inputGiebel">
                        Giebellänge im Grundriss (3-100m)
                    </label>
                    <input v-model="giebellaenge"  v-bind:class="[(giebellaenge < 3 || giebellaenge > 100) && giebellaenge != '' ? 'input-notallowed' : '']" @focus="focusDach" type="number" step="0.01" min="3" max="100" class="form-control form-control-sm luetfrink-input" id="inputGiebel" name="inGiebel" placeholder="" value="" required>
                </div>
                <div class="form-group" id="walmtraufe" v-if="dachform == 'Walmdach'" >
                    <label for="inputTraufeWalm" >
                        Länge der Traufe (kurze Seite beim Walmdach) (3-100m)
                    </label>
                    <input v-model="walmtrauflaenge" v-bind:class="[(walmtrauflaenge < 3 || walmtrauflaenge > 100) && walmtrauflaenge != '' ? 'input-notallowed' : '']" @focus="focusDach" type="number" step="0.01" min="3" max="100" class="form-control form-control-sm luetfrink-input" id="inputTaufeWalm" name="inWalmTraufe" placeholder="" required>
                </div>
            </div>
        </div>

        <div class="luetfrink-collapse collapsed text-secondary"  id="collapseHeadPfannenmodell" data-toggle="collapse" href="#collapsePfannenmodell" role="button" aria-expanded="false" aria-controls="collapsePfannenmodell"> 
            <span>Pfannenmodell</span>
            <img class="luetfrink-collapse-img" src="../../assets/img/down.svg" alt="Sektion Pfannenmodell Collapse-Pfeil"> 
        </div>
        <div class="collapse" id="collapsePfannenmodell" tabindex="-1">
            <div class="card card-body luetfrink-collapse-card">
            <label>Pfannenmodell</label>
                <select v-model="pfannenmodell" @focus="focusDach" class="form-control form-control-sm luetfrink-input" id="inputPfanneSelect" name="inPfanne" required>
                    <option selected disabled value="" hidden>Bitte auswählen</option>
                    <option v-for="(dachpfanne) in dachpfannen" v-bind:key="dachpfanne.id">{{dachpfanne.hersteller}}, {{dachpfanne.name}}</option>
                </select>
                <div v-if="dachpfannenObject != null">
                <label for="inputDecklaenge" class="ziegelinfo  mt-3" id="labelDecklaenge"  >
                    Decklänge in cm
                </label>
                <input type="text" class="form-control form-control-sm luetfrink-input ziegelinfo" id="inputDecklaenge"  :value="dachpfannenObject.decklaengemm/10" disabled>
                <label for="inputDeckbreite" class="ziegelinfo" id="labelDeckbreite" >
                    Deckbreite in cm
                </label>
                <input type="text" class="form-control form-control-sm luetfrink-input ziegelinfo" id="inputDeckbreite"  :value="dachpfannenObject.deckbreitemm/10" disabled>
                <label for="inputAnzahlQm" class="ziegelinfo" id="labelAnzahlQm"  >
                    Anzahl pro Quadratmeter
                </label>
                <input type="text" class="form-control form-control-sm luetfrink-input ziegelinfo" id="inputAnzahlQm"  :value="Math.round(1000000/(dachpfannenObject.deckbreitemm*dachpfannenObject.decklaengemm)*100)/100" disabled>
                </div>
                <label class="mt-3">Lattung</label>
                <div class="custom-control custom-checkbox luetfrink-check">
                    <input type="radio" value="30 x 50 mm" v-model="lattung" class="custom-control-input" name="inCheckLattung" id="checkLattung1"  required>
                    <label class="custom-control-label luetfrink-check" for="checkLattung1">30 x 50 mm</label>
                </div>
                <div class="custom-control custom-checkbox luetfrink-check">
                    <input type="radio" value="40 x 60 mm" v-model="lattung" class="custom-control-input" name="inCheckLattung" id="checkLattung2"  required>
                    <label class="custom-control-label luetfrink-check" for="checkLattung2">40 x 60 mm</label>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import {mapState, mapGetters, mapActions} from "vuex"

export default {
    name: "DachPfannenmodell",
     methods: 
    {
        focusDach()
        {
            if(this.isErlaubt)
            {
                this.$store.commit('setActiveLink', "dach")
                this.$store.commit('setActiveContent', "gebaeude")
            }
        },
        ...mapActions(['setDachpfannenObject'])
    },
    computed: {
        ...mapGetters(['getActiveLink', 'getActiveTrigger', 'getActiveContent', 'isErlaubt']),
        ...mapState({
            dachform: state => state.inputs.dachform,
            deckunterlage: state => state.inputs.deckunterlage,
            dachneigung: state => state.inputs.dachneigung,
            trauflaenge: state => state.inputs.trauflaenge,
            giebellaenge: state => state.inputs.giebellaenge,
            walmtrauflaenge: state => state.inputs.walmtrauflaenge,
            walmneigung: state => state.inputs.walmneigung,
            pfannenmodell: state => state.inputs.deckunterlage,
            dachpfannen: state => state.inputs.dachpfannen,
            dachpfannenObject: state => state.inputs.dachpfannenObject,
            lattung: state => state.inputs.lattung,
        }),
        dachform: {
            get () {
                return this.$store.state.inputs.dachform
            },
            set (value) {
                this.$store.commit('setDachform', value)
            }
        },
        deckunterlage: {
            get () {
                return this.$store.state.inputs.deckunterlage
            },
            set (value) {
                this.$store.commit('setDeckunterlage', value)
                this.focusDach()
            }
        },
        dachneigung: {
            get () {
                return this.$store.state.inputs.dachneigung
            },
            set (value) {
                this.$store.commit('setDachneigung', value)
                this.focusDach()
            }
        },
        trauflaenge: {
            get () {
                return this.$store.state.inputs.trauflaenge
            },
            set (value) {
                this.$store.commit('setTrauflaenge', value)
                this.focusDach()
            }
        },
        giebellaenge: {
            get () {
                return this.$store.state.inputs.giebellaenge
            },
            set (value) {
                this.$store.commit('setGiebellaenge', value)
                this.focusDach()
            }
        },
        walmtrauflaenge: {
            get () {
                return this.$store.state.inputs.walmtrauflaenge
            },
            set (value) {
                this.$store.commit('setWalmtrauflaenge', value)
                this.focusDach()
            }
        },
        walmneigung: {
            get () {
                return this.$store.state.inputs.walmneigung
            },
            set (value) {
                this.$store.commit('setWalmneigung', value)
                this.focusDach()
            }
        },
        pfannenmodell: {
            get () {
                return this.$store.state.inputs.pfannenmodell
            },
            set (value) {
                this.$store.commit('setPfannenmodell', value)
                this.setDachpfannenObject(this.pfannenmodell)
                this.focusDach()
            }
        },
        lattung: {
            get () {
                return this.$store.state.inputs.lattung
            },
            set (value) {
                this.$store.commit('setLattung', value)
            }
        },
    },
}
</script>

<style scoped>

.custom-image-control {
    position: relative;
    display: inline;
    min-height: 6.1rem;
}

.custom-image-checkbox
{
    z-index: -1;
    opacity: 0;
    position: absolute;
}

.custom-image-label
{
    cursor: pointer;
    width: 6rem;
    height: 6rem;
    margin-right: 2em;
    
}
.custom-image-label::before
{
    position: relative;
    display: block;
    pointer-events: none;
    content: "";
    width: 6rem;
    height: 6rem;
    transition: all .2s ease;
    z-index: 1;
}

.checkSatteldachLabel::before
{
    background: url("../../assets/img/Satteldach.png");
    background-size: 90%;
    background-repeat: no-repeat;
    background-position: center center;
}

.checkWalmdachLabel::before
{
    background: url("../../assets/img/Walmdach.png");
    background-repeat: no-repeat;
    background-size: 90%;
    background-position: center center;
}

.checkPultdachLabel::before
{
    background: url("../../assets/img/Pultdach.png");
    background-repeat: no-repeat;
    background-size: 90%;
    background-position: center center;
}

.custom-image-checkbox:checked~.custom-image-label::before
{
    -webkit-box-shadow: 0px 0px 6px 0px rgba(0,0,0, 0.151);
    -moz-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.151);
    box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.151);
}

.custom-image-checkbox:checked~.custom-image-label::after
{
    
}

@media (max-width:575.98px) {
.custom-image-control {
    min-height: 5.1rem;
}

.custom-image-label
{
    width: 5rem;
    height: 5rem;
}
.custom-image-label::before
{
    width: 5rem;
    height: 5rem;
}
    
}

</style>